export const GUEST_USER = 999999999999999;

export function insertHotjar({
  email,
  name,
  created_at,
  user_id,
  master,
  payment_kind,
  user_group,
  user_admin,
  account_id,
  account_name,
  account_user_group,
  role,
  pod,
  path_url,
  universe_id,
  universe_name,
  user_type,
  studio,
}) {
  window.hj('identify', user_id,
    email,
    name,
    created_at,
    user_id,
    master,
    payment_kind,
    user_group,
    user_admin,
    user_type,
    account_id,
    account_name,
    account_user_group,
    role,
    pod,
    path_url,
    universe_id,
    universe_name,
    studio,
  );
}

export function insertHotjarPlugin(userData) {
  /* eslint-disable */
  (function (h, o, t, j, a, r) {
    h.hj = h.hj || function () {
      (h.hj.q = h.hj.q || []).push(arguments);
    };
    h._hjSettings = { hjid: 1408370, hjsv: 6 };
    a = o.getElementsByTagName('head')[0];
    r = o.createElement('script');
    r.async = 1;
    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
    a.appendChild(r);
  }(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv='));

  insertHotjar(userData);
}